import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ontruck/orc';
import cx from 'classnames';

const ButtonLoading = (props) => {
  const {
    className,
    text,
    title,
    type,
    icon,
    fullWidth,
    ghost,
    nude,
    skin,
    size,
    disabled,
    iconPosition,
    loading,
    handleClick,
    testId,
    extraClass,
  } = props;
  return (
    <div className={className} data-testid="button-loading">
      <div className="button-loading">
        <Button
          className={cx('button-loading__button', { [extraClass]: extraClass })}
          title={title}
          icon={icon}
          fullWidth={fullWidth}
          ghost={ghost}
          nude={nude}
          skin={skin}
          size={size}
          type={type}
          disabled={disabled || loading}
          iconPosition={iconPosition}
          onClick={handleClick}
          data-testid={`${testId ? testId : 'button-loading__button'}`}
        >
          {(loading || text) && (
            <div className="button-loading__container">
              {loading && (
                <div
                  className="button-loading__icon button-loading__icon--loading"
                  data-testid="button-loading__loading-icon"
                >
                  ◠
                </div>
              )}
              {text && <span className="button-loading__text">{text}</span>}
            </div>
          )}
        </Button>
      </div>
    </div>
  );
};

ButtonLoading.defaultProps = {
  text: '',
  loading: false,
  testId: '',
  skin: 'primary',
  fullWidth: false,
  ghost: false,
  nude: false,
  disabled: false,
  size: 'M',
  iconPosition: 'left',
  type: 'button',
  handleClick: () => {
    /*noop*/
  },
};

ButtonLoading.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  fullWidth: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  type: PropTypes.oneOf(['button', 'submit']),
  nude: PropTypes.bool,
  ghost: PropTypes.bool,
  disabled: PropTypes.bool,
  skin: PropTypes.oneOf(['primary', 'secondary', 'cancel', 'pinky']),
  size: PropTypes.oneOf(['XS', 'S', 'M', 'L', 'XL']),
  loading: PropTypes.bool,
  handleClick: PropTypes.func,
  testId: PropTypes.string,
  extraClass: PropTypes.string,
};
export default ButtonLoading;
